import { service } from '../../../../helpers/http' 

export const ActionGetCustomers = ({ dispatch }, payload) => { 
    return service({
        module: 'customer',
        action: 'getCustomers',
        payload: payload
    })
}

export const ActionPostCustomers = ({ dispatch }, payload) => {

    return service({
        module: 'customer',
        action: 'postCustomers',
        payload: payload
    })
    
}

export const ActionPutCustomers = ({ dispatch }, payload) => {

    return service({
        module: 'customer',
        action: 'putCustomers',
        payload: payload
    })
    
}

export const ActionDeleteCustomers = ({ dispatch }, payload) => {

    return service({
        module: 'customer',
        action: 'deleteCustomers',
        payload: payload
    })
    
}
